/**
* Created by vouill on 5/7/18.
*/

<template>
  <SignForm
    @submit="signup"
    :is-sign-in="true"
    :status="status"/>
</template>

<script>
import SignForm from "../ui/sign-form";
import { actions, getApiStatus } from "vuex-api";
import { mapState } from "vuex";

export default {
  name: "Singup",
  methods: {
    signup: function({ email, password }) {
      this.$store.dispatch(actions.request, {
        requestConfig: {
          baseURL: process.env.VUE_APP_API_URL
        },
        method: "POST",
        url: "/api/users/authenticate",
        data: {
          email,
          password
        },
        keyPath: ["identification"],
        onSuccess: {
          executeFunction: ({ data: { id_token } }) => {
            localStorage.setItem("token", id_token);
            this.$store.dispatch(actions.request, {
              requestConfig: {
                baseURL: process.env.VUE_APP_API_URL
              },
              method: "GET",
              url: "/api/users/me",
              headers: { Authorization: `Bearer ${id_token}` },
              keyPath: ["me"],
              onSuccess: {
                executeFunction: () => {
                  this.$router.push("/");
                }
              }
            });
          }
        }
      });
    }
  },
  computed: mapState({
    status: getApiStatus("identification")
  }),
  components: { SignForm }
};
</script>
